<template>
 <div id="WorkOrderSalesInvoiceView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="web-right-sidebar"> <!--right sidebar-->
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab">
                <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Invoice Details</a>
                    <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                </div>
                <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                        <div class="list-view">
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Invoice Type:</label>
                                <span class="col">{{invType}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Invoice #:</label>
                                <span class="col">{{invoice_number}}</span>
                            </div>
                            <div v-if="ref != ''" class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Reference :</label>
                                <span v-fp-html="ref" class="col"></span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Customer :</label>
                                <span class="col">{{customer}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Terms :</label>
                                <span class="col">{{terms}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">PO# :</label>
                                <span class="col">{{po_no}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Invoice Date :</label>
                                <span class="col">{{invoice_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Due Date :</label>
                                <span class="col">{{due_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Unit :</label>
                                <span class="col">{{unit_no}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Meter :</label>
                                <span class="col">{{meter}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">VIN :</label>
                                <span class="col">{{vin_number}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Facility :</label>
                                <span class="col">{{facility}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Date In :</label>
                                <span class="col">{{date_in}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Date Out :</label>
                                <span class="col">{{date_out}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Created Date :</label>
                                <span class="col">{{created_at}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Open Amount :</label>
                                <span class="col">{{open_amount}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Total Amount :</label>
                                <span class="col">{{total_amount}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                        <invoice-activity-log-list :activityLogVal="activityLogsTabValue"></invoice-activity-log-list>
                    </div>
                </div>
            </div>
        </div>
    </div><!--right sidebar-->
    <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
        <template v-if="cantAccessPage === true">
            <div class="page-name asset-view-page-name purchase-order-title">
                <div class="page-title"> # {{invoice_number}}</div>
                <div class="web-action-btn btn-groups text-right">
                    <button type="button" v-if="canAddCrm  &&  deleted_at == null" class="btn btn-secondary" v-on:click="crmSection()" >
                        <i class="fp-agreement"> </i> {{crmBtnTitle}}
                    </button>
                    <template v-if="!isCrmSection">
                    <button v-if="deleted_at == null" type="submit" id="previewInvoiceBtn" v-on:click="previewInvoice()" class="btn btn-secondary"><i class="fp-invoice"></i> Preview Invoice
                    </button>
                    <button v-if="deleted_at == null" type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class="btn btn-secondary"><i class="fp-download"></i> Download PDF
                    </button>
                    <button v-if="deleted_at == null && work_order_status != '' && work_order_status != 'approved'" type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                    </button>
                    <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" ><i class="fp-back"> </i>    Back </button>
                    </template>
                </div>
                <div class="mobile-action-btn elipse-btn">
                    <button type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                    </button>
                    <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" ><i class="fp-back"> </i>    Back </button>
                    <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                        <i class="fp-ellipsis-v"></i>
                    </button>
                    <div id="myDropdown" class="dropdown-content">
                        <ul>
                            <li v-if="canAddCrm"><a  class="" href="javascript:void(0);" v-on:click="crmSection()" > CRM</a></li>
                            <li><a id="previewInvoiceBtn" v-on:click="previewInvoice()" class=""> Preview Invoice</a></li>
                            <li><a  id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class=""> Download PDF</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div id="workorder-detail work-order-view-top" class="admin-page-content wo-invoice-view">
                    <template v-if="!isCrmSection">
                    <section class="internal-container border-top-table-fl">
                        <template v-if="invoiceItemsArr.length == 0 || invoiceItemsArr == undefined">
                            <div class="lineitem-main-section">
                            <h5>No Line Item Added</h5>
                            </div>
                        </template>
                        <template v-else>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="invoiceItemsArr != undefined && invoiceItemsArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>VMRS System / Part Number</th>
                                            <th>Labor / Part Description</th>
                                            <th class="text-right">Hours</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Unit Price </th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(invItems , itemKey) in invoiceItemsArr">
                                            <template v-for="(invUnitItems , unititemKey) in invoiceItemsArr[itemKey]['unit_items']">
                                                <tr :key="'item1'+unititemKey">
                                                    <template v-if="invUnitItems.name != '-'">
                                                        <td><template v-if="invUnitItems.name != null">{{invUnitItems.name}}</template><p class="text-center" v-else>-</p></td>
                                                        <td colspan="5"></td>
                                                    </template>
                                                </tr>

                                                <template v-for="(invUnitSubItems , unitsubitemKey) in invoiceItemsArr[itemKey]['unit_items'][unititemKey]['sub_items']">
                                                    <tr :key="'item2'+unitsubitemKey">
                                                        <td> &nbsp;&nbsp;&nbsp;&nbsp; {{invUnitSubItems.vmrs_system_part_number}}</td>
                                                        <td>{{invUnitSubItems.description}}</td>
                                                        <td class="text-right">{{invUnitSubItems.hours}}</td>
                                                        <td class="text-right">{{invUnitSubItems.quantity}}</td>
                                                        <td class="text-right">{{invUnitSubItems.unit_price}}</td>
                                                        <td class="text-right">{{invUnitSubItems.amount}}</td>
                                                    </tr>
                                                </template>
                                                <tr :key="'item3'+unititemKey">
                                                      <template>
                                                        <td>&nbsp;&nbsp;&nbsp;&nbsp; Complaint </td>
                                                        <td colspan="5">{{invUnitItems.complaint}}</td>

                                                      </template>
                                                </tr>
                                                <tr :key="'item4'+unititemKey">
                                                      <template>
                                                        <td>&nbsp;&nbsp;&nbsp;&nbsp; Cause </td>
                                                        <td colspan="5">{{invUnitItems.cause}}</td>

                                                      </template>
                                                </tr>
                                                <tr :key="'item5'+unititemKey">
                                                      <template>
                                                        <td>&nbsp;&nbsp;&nbsp;&nbsp; Correction </td>
                                                        <td colspan="5">{{invUnitItems.correction}}</td>

                                                      </template>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <!-- Sales Tax Exemption Message on basis of Customer Credit Information -->
                    <section class="internal-container border-top-table-fl" v-if="tax_exempt != ''">
                        <h6 class="color-red">NOTE : {{tax_exempt}}</h6>
                    </section>
                    <section class="internal-container border-top-table-fl" v-if="paymentArr != undefined && paymentArr.length > 0">
                        <div class="journal-title">
                            <h5> Payment Detail </h5>
                        </div>
                        <template>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="paymentArr != undefined && paymentArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th># Document</th>
                                            <th class="text-right">Amount</th>
                                            <th>Date</th>
                                            <th>Posted By</th>
                                            <th>Processed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(pay , payKey) in paymentArr">
                                            <tr :key="'payment'+payKey">
                                                <td v-fp-html="pay.payment_no"></td>
                                                <td class="text-right">{{pay.amount}}</td>
                                                <td>{{pay.date}}</td>
                                                <td>{{pay.posted_by}}</td>
                                                <td>{{pay.payment_by}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Total Labor: </td>
                                            <td class="text-right"> {{total_labor}} </td>
                                        </tr>
                                        <tr>
                                            <td> Total Parts: </td>
                                            <td class="text-right"> {{total_parts}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total Sublet: </td>
                                            <td class="text-right"> {{total_sublet}} </td>
                                        </tr>
                                        <tr>
                                            <td> Other Charges: </td>
                                            <td class="text-right"> {{other_charges}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Shop Supplies: </td>
                                            <td class="text-right"> {{shop_supplies}} </td>
                                        </tr>
                                        <tr>
                                            <td> Total Before Tax: </td>
                                            <td class="text-right"> {{sub_total}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> SALES TAX: </td>
                                            <td class="text-right"> {{sales_tax}} </td>
                                        </tr>
                                        <tr>
                                            <td> Total Taxes: </td>
                                            <td class="text-right"> {{total_tax}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total Due This Invoice: </td>
                                            <td class="order-total text-right"> {{total}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> <!--Description section-->
                    <!-- Journals -->
                    <section class="internal-container border-top-table-fl mt-4 loader-position">
                        <div :class="`loader-div${loaderClass}`" v-show="glLoading"></div>
                        <div class="journal-title" >
                            <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                        </div>
                        <div :id="'demo'" class="accordian-body collapse show">
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Account</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="journalsArr != undefined && journalsArr.length > 0">
                                        <template v-for="(journalItem , journalKey) in journalsArr">
                                                <tr :key="'journal'+journalKey">
                                                    <template v-if="journalItem.account_description == 'Total'">
                                                        <td class="text-right">{{journalItem.account_description}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td>{{journalItem.account_description}}</td>
                                                    </template>
                                                    <td class="text-right">{{journalItem.debit}}</td>
                                                    <td class="text-right">{{journalItem.credit}}</td>
                                                    <td class="text-right">{{journalItem.journal_amount}}</td>
                                                </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4"><h5>No GL Found</h5></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                    </template>
                    <template v-else>
                        <!-- Invoice Crm -->
                        <div id="invoice-crm-list" class="admin-page-content invoice-view list-view">
                            <template v-if="crmAdd">
                                <crm-create :fromModule="invoiceObj"></crm-create>
                            </template>
                            <template v-else>
                                <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                    <div class="bg-white data-table p-0">
                                        <invoice-crm-list v-if="enableInvoiceCrm" :moduleVal="'invoice'" :moduleId="invoiceId"></invoice-crm-list>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </template>

        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';

import CrmCreate from "@/components/CrmCreate.vue";
Vue.component("crm-create", CrmCreate);

Vue.component("invoice-activity-log-list", ActivityLogListView);
export default {
    name: "WorkOrderSalesInvoiceView",
    components: {
        invoiceCrmList: () => import('@/components/CrmList.vue')
    },
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        loading:false,
        glLoading:false,
        permissions:[],
        cantAccessPage:"",
        canAdd:false,
        canUpdate:false,
        invoiceId : 0,
        path:"",
        activetab: 1,
        activityLogsTabValue: "invoiceloadList",
        invoiceItemsArr:[],
        invoice_number:'',
        deleted_at:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        unit_no:'',
        vin_number:'',
        meter:'',
        facility:'',
        date_in:'',
        date_out:'',
        sub_total:'',
        tax_amount:'',
        total_labor:'',
        total_parts:'',
        total_sublet:'',
        total_environmental:'',
        other_charges:'',
        shop_supplies:'',
        sales_tax:'',
        total_tax:'',
        total:'',
        invoice_status:'',
        journalsArr:[],
        ref:'',
        tax_exempt:'',
        isCrmSection:false,
        enableInvoiceCrm:false,
        canAddCrm:false,
        crmAdd:false,
        invoiceObj:{},
        crmBtnTitle:"CRM",
        fromUrl:"",
        from:"",
        paymentArr:[],
        invType:"",
        work_order_status:"",
        created_at:'',
        open_amount:'',
        total_amount:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'add_crm') {
                    self.canAddCrm = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        if(this.$route.query.fromUrl != "" && this.$route.query.fromUrl != undefined){
          self.fromUrl = atob(this.$route.query.fromUrl);
        }
        if(this.$route.query.from == "customer"){
          self.from = this.$route.query.from;
        }
        self.invoiceId = this.$route.params.id.toString();
        //set value in invoice object for crm
        self.invoiceObj.module = "invoice";
        self.invoiceObj.invoice_id = this.$route.params.id;
        self.invoiceObj.flag = "add";
        self.invoiceObj.crm_id = "";
        self.getPermissions();
        self.loadInvoiceData();
    },
    metaInfo() {
        return {
            title: (this.invoice_number != "") ? this.invoice_number + " | Customer Invoice View | " +process.env.COPYRIGHT_NAME:"Customer Invoice View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/invoice/list");
        },
        editInvoice() {
            var self = this;
            if (self.$route.params.from != undefined && self.$route.params.from == 'woInvList') {
                self.$router.push({name: 'WorkOrderInvoiceEdit',params:{id:self.invoiceId,from:'woInvList'}});
            }else{
                self.$router.push("/invoice/wo/edit/" + self.invoiceId);
            }
        },
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/workorder/details",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{'invoice_id':self.invoiceId},
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        self.invoiceArr = data.content;
                        self.invoiceObj.customer_id = data.content[0].customer_id;
                        if (data.content[0].vehicle_id != undefined && data.content[0].vehicle_id != null) {
                            self.invoiceObj.vehicle_id = data.content[0].vehicle_id;
                        }
                        self.created_at = data.content[0].created_at;
                        self.open_amount = data.content[0].open_amount;
                        self.total_amount = data.content[0].total;
                        self.due_date = data.content[0].due_date;
                        self.po_no = data.content[0].cpo_number;
                        self.invoice_number = data.content[0].invoice_number;
                        self.deleted_at = data.content[0].deleted_at;
                        self.customer = data.content[0].customer_code + " | " + data.content[0].customer_name;
                        self.invoice_date = data.content[0].invoice_date;
                        self.unit_no = data.content[0].unit_no;
                        self.vin_number = data.content[0].vin_number;
                        self.meter = data.content[0].meter;
                        self.facility = data.content[0].location_name;
                        self.date_in = data.content[0].date_in;
                        self.date_out = data.content[0].date_out;
                        self.total_labor = data.content[0].total_labor;
                        self.total_parts = data.content[0].total_part;
                        self.total_sublet = data.content[0].total_sublet;
                        // self.total_environmental = data.content[0].total_environmental;
                        self.other_charges = data.content[0].other_charges;
                        self.shop_supplies = data.content[0].shop_supplies;
                        self.sub_total = data.content[0].total_before_tax;
                        self.sales_tax = data.content[0].sales_tax;
                        self.total_tax = data.content[0].total_taxes;
                        self.total = data.content[0].total;
                        self.invType = data.content[0].invoice_type;
                        self.terms = data.content[0].term_name;
                        if (data.content[0].items != undefined) {
                            self.invoiceItemsArr = data.content[0].items;
                        }else{
                            self.invoiceItemsArr = [];
                        }
                        
                        if (data.content[0].reference != undefined) {
                            self.ref = data.content[0].reference;
                        }else{
                            self.ref = '';
                        }
                        if (data.content[0].tax_exempt != undefined && data.content[0].tax_exempt != null) {
                            self.tax_exempt = data.content[0].tax_exempt;
                        }
                        self.paymentArr = data.content[0].payment;
                        if (data.content[0].invoice_status != undefined) {
                            self.invoice_status = data.content[0].invoice_status;
                        }
                        self.work_order_status = data.content[0].work_order_status;

                        // if (data.content[0].journals != undefined) {
                        //     self.journalsArr = data.content[0].journals;
                        // }else{
                        //     self.journalsArr = [];
                        // }
                        self.getGLEntry(data.content[0].invoice_number);

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-view');
                }
            });
        },
        getGLEntry(invNo) {

            var self = this;
            self.glLoading = true;
            $.ajax({
                url: process.env.ROOT_API + "/module/gl",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{'id':self.invoiceId,'doc_no':invNo,'name':'customer invoice'},
                success: function (data) {
                    self.glLoading = false;
                    if (data.status == "success") {
                        self.journalsArr = data.content;
                        
                    }
                },
                error: function (jqXHR, exception) {
                    self.glLoading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-view');
                }
            });
        },
        activityLogs(){

          var self = this;
        //   var path = window.location.pathname;
        //   var segments = path.split("/");

          self.$root.$emit('activity_log_opted','invoice',self.invoiceId);
          self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
        generateInvoicePdf(){

            var self = this;

            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:"WO",
                    invoice_origin:"manual"
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'workorder-invoice-pdf');
                }
            });

        },
        previewInvoice() {
            var self = this;
            if (self.$route.params.from != undefined && self.$route.params.from == 'woInvList') {
                self.$router.push({name: 'WorkOrderInvoiceView',params:{id:self.invoiceId,from:'woInvList'}});
            }else{
                self.$router.push('/invoice/wo/preview/' + self.invoiceId);
            }
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableInvoiceCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableInvoiceCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = "";
            self.invoiceObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = crmId;
            self.invoiceObj.flag = "update";
        },
        backInvoiceList() {
            var self = this;
             var url = '/invoice/list';
             var fromPage = '';

            if ( self.fromUrl != "" && self.fromUrl != null ) {
              if(self.from == 'customer'){
                var  selectTab = '?viewTab=invoice';
                url = self.fromUrl+selectTab;
                fromPage = url;
              }else{
                url = self.fromUrl;
                fromPage = url;
              }

            }
            if(self.$route.params.from != undefined && self.$route.params.from == 'woInvList'){
                url = '/workorder/invoice/list';
            }
            if(this.$route.query.from != undefined && this.$route.query.from == 'gl'){
               self.$router.push('/report/general-ledger');
            }else{
                if ( self.fromPage != "" && self.fromPage != null ) {
                    self.redirectPageUrl(fromPage);
                }else{
                    self.redirectPageRoleWise(url,"/workorder/invoice/list","wo-invoice");
                }
            }


        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/WorkOrderSalesInvoiceView.vue